import { defineStore } from 'pinia'
import { apiGameInit, apiGetGameHomeConfig } from "@/api/gameApi";
import { GameConfigItem, GameInitType } from "@/api/types/gameTypes";
import { GoodsItemStatusTypes } from '@/api/types/goodsTypes'
import { GameConfigType } from '@/hooks/useGameConfig'

export interface GameItemType {
  game_detail: string
  game_icon: string
  game_name: string
  mall_game_id: number
}

const themeList: { [K: string]: string } = {
  0: 'theme-dark',
  1: 'theme-light'
}

export const useGameStore = defineStore('game', {
  state: () => ({
    gameListCn: [] as GameConfigItem[],
    gameIcon: '' as string,
    currentGameId: 0 as number,
    currentGameConfig: {} as GameConfigType,
    currentGameInfo: {} as GameInitType,
    // 预检商品状态列表
    preCheckList: {} as { [K: string]: GoodsItemStatusTypes },
    // vip等级描述图
    vipDescImg: '',
    //   角色ID图
    roleIdImg: '',
    // 是否开启会员等级
    levelFlag: false,
    isDisabledMall: -1,
    payRegions: [] as string[]
  }),
  getters: {
    // 是否需要对商品预检
    preCheck: state => state.currentGameInfo?.preCheck || false,
    levelFlag: state => state.currentGameInfo?.levelFlag,
    currentTheme: state => themeList[state.currentGameInfo?.theme] || 'theme-light'
  },
  actions: {
    setPayRegions(data: string[]) {
      this.payRegions = data
    },
    setImgConfig(imgs: any) {
      this.vipDescImg = imgs.vipDescImg
      this.roleIdImg = imgs.roleIdImg
    },
    // 获取游戏配置
    async getGameInit(gameId: number | string) {
      this.isDisabledMall = -1
      const res = await apiGameInit({ mall_game_id: gameId })
      if (res.code !== 0) return
      this.isDisabledMall = res.data.disable ? 0 : 1
      this.currentGameInfo = {
        ...res.data,
        orderExpireTime: res.data.orderExpireTime + 5000
      }
      // document.body!.className = 'theme-light' // themeList[res.data.theme] ||
      // document.body!.className = 'theme-dark'
    },
    setCurrentGameId(id: number) {
      this.currentGameId = id
    },
    setCurrentGameConfig(config: GameConfigType) {
      this.currentGameConfig = config
    },
    // 设置所有预检商品状态
    setPreCheckList(items: { [K: string]: GoodsItemStatusTypes }) {
      this.preCheckList = items
    },
    async getGameConfig (type?: 'home' | 'mall') {
      this.gameListCn = []
      const res = await apiGetGameHomeConfig()
      if (res.code === 0) {
        this.gameListCn = res.data
        if(type === 'mall' && res.data.length) {
          this.gameIcon = res.data.filter(item => item.game_url === this.currentGameConfig.path)[0]?.game_icon
        }
      }
    }
  },
  persist: {
    key: '__mall__game__',
    storage: localStorage,
    paths: ['currentGameId', 'payRegions']
  }
})
